<template>
  <l-horizontal-scroll-bar
    :cards="recommendedCourses"
    :product-type="recommendedCourses.productType"
    :recommended-course-cards="true"
    variant="homepage"
  >
    <template #icon>
      <img
        src="//summitproedu.imgix.net/redesign-assets/icons/2025/formats.svg"
        alt="On Demand CE"
      />
    </template>
    <template #title>
      Other therapists also liked...
    </template>
  </l-horizontal-scroll-bar>
</template>

<script>
import useFetchCustom from '../../composables/useFetchCustom';

export default {
  name: 'CourseRecommenderScrollBar',
  props: {
    productType: {
      type: String,
      default: 'VIDEO',
    },
    cards: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: 'default',
    },
    // use this sessionId to look up course recs
    sessionId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      recommendedCourses: [],
      recommendedCoursesCache: {},
    };
  },
  watch: {
    sessionId(newSelectedSession) {
      console.log('SELECTED SESSION CHANGED', newSelectedSession);
      this.getCourseRecommendations();
    },
  },
  mounted() {
    this.getCourseRecommendations();
  },
  methods: {
    async getCourseRecommendations() {
      const courseRecKeys = Object.keys(this.recommendedCoursesCache); // key is stored as sessionId
      console.log(courseRecKeys);
      // store courses in cache obj and match to sessionId to save an api call if user goes back to previous session
      if (courseRecKeys.length > 0 && courseRecKeys.includes(this.sessionId)) {
        this.recommendedCourses = this.recommendedCoursesCache[this.sessionId];
      }
      else {
        this.recommendedCourses = await useFetchCustom('GET', `/course/recommendations/${this.sessionId}`);
        this.recommendedCoursesCache = {
          ...this.recommendedCoursesCache,
          [this.sessionId]: this.recommendedCourses,
        };
      }
    },
  },
};
</script>
